import styled from 'styled-components';
import ProfileHeaderSVG from '../../assets/header/ic-my-profile.svg';

const ProfileHeaderIcon = styled(ProfileHeaderSVG as React.SFC<React.SVGProps<SVGSVGElement>>,)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  fill: ${props => props.color};
  margin: ${props => props.margin};
`;

export default ProfileHeaderIcon;
